import { get } from 'lodash-es';
import { emptyArray } from 'ui-components/default-props/empty';
import { FIRST_PAGE, PAGE_SIZE_50 } from '../../../services/pagination-service';

export const selectIsLoading = (state) => get(state, 'isLoading');
export const selectSalesOrders = (state) => get(state, 'salesOrders', emptyArray);
export const selectFulfillmentPlans = (state) => get(state, 'fulfillmentPlans', emptyArray);
export const selectTotalCount = (state) => get(state, 'totalRecords', 0);
export const selectPage = (state) => get(state, 'page', FIRST_PAGE);
export const selectPageSize = (state) => get(state, 'pageSize', PAGE_SIZE_50);
export const selectTotalPages = (state) => get(state, 'totalPages', 0);
export const selectViewStartingCount = (state) => get(state, 'viewStartingCount', 0);
export const selectViewEndingCount = (state) => get(state, 'viewEndingCount', 0);
